"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LockedRoute = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/**
 * You can use this component to lock a route in a NextJS application behind a Lock.
 * A Lock is any condition you want to check if it is fulfilled.
 *
 * Examples: Show a page only if a user is in a COF bucket
 *
 * Usage: Add this to the topmost of your route. Nothing should be above this component.
 *
 */
const web_env_1 = require("@snapchat/web-env");
const router_1 = require("next/router");
const react_1 = require("react");
/**
 *
 */
function LockedRoute({ children, backupRoute, lockingEvaluator }) {
    const [routingDecisionComplete, setRoutingDecisionComplete] = (0, react_1.useState)(false);
    const { replace, basePath } = (0, router_1.useRouter)();
    const lockingEvaluatorRef = (0, react_1.useRef)(lockingEvaluator);
    lockingEvaluatorRef.current = lockingEvaluator;
    (0, react_1.useEffect)(() => {
        function goToBackupRoute() {
            const isRelativeRoute = backupRoute.startsWith("/");
            const windowObj = (0, web_env_1.getWindow)();
            if (isRelativeRoute) {
                void replace(backupRoute).catch(() => {
                    // NextJS Routing failed. Do a browser replace to force it
                    // eslint-disable-next-line no-restricted-globals
                    const backupRouteUrl = `${window.location.origin}/${basePath}/${backupRoute}`;
                    // if any prop has any additional slashes
                    const sanitizedURL = backupRouteUrl.replace("//", "/");
                    windowObj?.location.replace(sanitizedURL);
                });
            }
            else {
                windowObj?.location.replace(backupRoute);
            }
        }
        let isMounted = true;
        void lockingEvaluatorRef
            .current()
            .then((result) => {
            if (!result) {
                throw new Error("Route is locked");
            }
            else {
                if (isMounted) {
                    setRoutingDecisionComplete(true);
                }
            }
        })
            .catch(() => {
            if (isMounted) {
                goToBackupRoute();
            }
        });
        return () => {
            isMounted = false;
        };
    }, [replace, backupRoute, basePath]);
    // Only show the page if routing decision is complete
    return routingDecisionComplete ? (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children }) : null;
}
exports.LockedRoute = LockedRoute;
//# sourceMappingURL=LockedRoute.js.map